module.exports = __webpack_public_path__ + "static/media/retire_distinct_strategies.f105572f.jpg";